(function () {
  'use strict';

  function updateOverflowState(root) {
    var wrap = root.querySelector('[data-upgrade-grid-wrap]');
    if (!wrap) return;
    var hasOverflow = wrap.scrollWidth > wrap.clientWidth + 1;
    root.classList.toggle('is-scrollable', hasOverflow);
  }

  function initUpgrade(root) {
    if (!root || root.getAttribute('data-fp10-upgrade-initialized') === 'true') return;
    root.setAttribute('data-fp10-upgrade-initialized', 'true');
    updateOverflowState(root);
    var onResize = function () {
      updateOverflowState(root);
    };
    window.addEventListener('resize', onResize);
    root._fp10UpgradeCleanup = function () {
      window.removeEventListener('resize', onResize);
      root.removeAttribute('data-fp10-upgrade-initialized');
      root._fp10UpgradeCleanup = null;
    };
  }

  function initAll() {
    document.querySelectorAll('[data-fp10-upgrade]').forEach(initUpgrade);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev || !ev.target) return;
    ev.target.querySelectorAll('[data-fp10-upgrade]').forEach(initUpgrade);
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    if (!ev || !ev.target) return;
    ev.target.querySelectorAll('[data-fp10-upgrade]').forEach(function (root) {
      if (root._fp10UpgradeCleanup) root._fp10UpgradeCleanup();
    });
  });
})();
